"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    inputTextEmphases: ()=>inputTextEmphases,
    inputTextVariants: ()=>inputTextVariants,
    inputTextSizes: ()=>inputTextSizes
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const inputTextVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: 'group relative flex flex-col gap-1 antialiased transition duration-200',
        labelSlot: 'text-primary-13 text-body3 relative cursor-text transition duration-200',
        inputWrapper: [
            'bg-primary-1 relative grid grid-cols-1 content-center gap-3 rounded-xl border',
            'border-primary-6 focus-within:border-primary-8',
            'group-data-focused:shadow-input-focus'
        ],
        input: [
            'col-start-1 row-start-1 block w-full px-4 py-2 transition-colors focus:outline-none',
            'text-primary-14 placeholder:text-primary-10 text-body1',
            'aria-[invalid=true]:border-error-8'
        ],
        textSlot: 'text-body3 ml-4 flex justify-between',
        helperTextSlot: 'text-primary-13',
        errorTextSlot: 'text-error-8 col-start-1 row-start-1 self-center justify-self-end',
        successTextSlot: 'col-start-1 row-start-1 self-center justify-self-end',
        characterCount: 'text-neutral-7 text-right',
        iconLeft: 'text-primary-8 pointer-events-none col-start-1 row-start-1 self-center pl-4',
        iconRight: 'text-primary-6 pointer-events-none col-start-1 row-start-1 self-center justify-self-end pr-4'
    },
    variants: {
        isInset: {
            true: {
                labelSlot: [
                    'text-primary-10 absolute left-[17px] z-10 mb-0',
                    'group-data-focused:text-primary-13 group-data-focused:text-body3',
                    'group-data-filled:text-primary-13 group-data-filled:text-body3'
                ],
                input: 'group-data-filled:placeholder:invisible group-data-filled:text-primary-13 translate-y-2'
            }
        },
        size: {
            sm: {
                inputWrapper: 'h-[32px] rounded-xl',
                labelSlot: 'group-data-filled:text-body3',
                input: 'group-data-filled:text-body1'
            },
            md: {
                inputWrapper: 'h-[48px]',
                labelSlot: 'group-data-filled:text-body3',
                input: 'group-data-filled:text-body1'
            },
            lg: {
                inputWrapper: 'h-[56px]',
                labelSlot: 'group-data-filled:text-body3',
                input: 'group-data-filled:text-body1'
            }
        },
        emphasis: {
            regular: {},
            medium: {},
            bold: {
                inputWrapper: [
                    'bg-primary-1/20',
                    'border-primary-1/40 focus-within:border-primary-4'
                ],
                labelSlot: [
                    'text-primary-1 group-data-filled:text-primary-1 group-data-focused:text-primary-1',
                    'not-group-data-filled:text-primary-1'
                ],
                input: 'text-primary-1 group-data-filled:text-primary-1 placeholder:text-primary-6'
            }
        },
        hasIconLeft: {
            true: {
                input: 'pl-13'
            }
        },
        hasIconRight: {
            true: {
                input: 'pr-13'
            }
        },
        hasPlaceholder: {
            true: {}
        },
        isDisabled: {
            true: {
                inputWrapper: 'bg-neutral-2 disabled:text-primary-6 cursor-not-allowed',
                labelSlot: 'disabled:text-primary-6 cursor-not-allowed opacity-50',
                input: 'bg-neutral-2 disabled:text-primary-6 cursor-not-allowed opacity-50'
            },
            false: {
                inputWrapper: [
                    'hover:border-primary-10 group-data-focused:hover:border-primary-8 transition',
                    'hover:shadow-input-hover transition'
                ]
            }
        },
        error: {
            true: {
                input: 'pr-8',
                inputWrapper: [
                    'border-error-7',
                    'group-data-focused:shadow-input-error hover:shadow-input-error transition'
                ]
            },
            false: {
                inputWrapper: [
                    'focus-within:ring-primary-8/20 focus-within:ring-2'
                ]
            }
        },
        success: {
            true: {
                input: 'pr-8'
            },
            false: {}
        }
    },
    compoundVariants: [
        {
            isInset: true,
            size: 'sm',
            class: {
                labelSlot: [
                    'not-group-data-filled:translate-y-1 not-group-data-filled:text-body1',
                    'group-data-filled:translate-y-0',
                    'group-data-focused:translate-y-0'
                ],
                input: 'translate-y-1.5'
            }
        },
        {
            isInset: true,
            hasPlaceholder: true,
            size: 'sm',
            class: {
                labelSlot: 'not-group-data-filled:translate-y-0'
            }
        },
        {
            isInset: true,
            size: 'md',
            class: {
                labelSlot: [
                    'not-group-data-filled:translate-y-3 not-group-data-filled:text-body1',
                    'group-data-filled:translate-y-1.5',
                    'group-data-focused:translate-y-1.5'
                ]
            }
        },
        {
            isInset: true,
            hasPlaceholder: true,
            size: 'md',
            class: {
                labelSlot: 'not-group-data-filled:translate-y-1.5'
            }
        },
        {
            isInset: true,
            size: 'lg',
            class: {
                labelSlot: [
                    'not-group-data-filled:translate-y-4 not-group-data-filled:text-body1',
                    'group-data-filled:translate-y-2',
                    'group-data-focused:translate-y-2'
                ]
            }
        },
        {
            isInset: true,
            hasPlaceholder: true,
            size: 'lg',
            class: {
                labelSlot: 'not-group-data-filled:translate-y-2'
            }
        },
        {
            hasPlaceholder: true,
            isInset: true,
            class: {
                labelSlot: 'text-body3 not-group-data-filled:text-body3 text-primary-13',
                input: 'group-data-filled:placeholder:visible no-group-data-focused:placeholder:visible'
            }
        },
        {
            hasIconLeft: true,
            class: {
                input: 'ml-0'
            }
        },
        {
            hasIconLeft: true,
            isInset: true,
            class: {
                labelSlot: 'left-13 ml-[1px]'
            }
        },
        {
            isDisabled: true,
            emphasis: 'regular',
            class: {
                inputWrapper: 'bg-neutral-2 disabled:text-primary-6 cursor-not-allowed',
                labelSlot: 'disabled:text-primary-6 cursor-not-allowed opacity-50',
                input: 'bg-neutral-2 disabled:text-primary-6 cursor-not-allowed opacity-50'
            }
        },
        {
            isDisabled: true,
            emphasis: 'medium',
            class: {
                inputWrapper: 'bg-neutral-2 disabled:text-primary-8 cursor-not-allowed',
                labelSlot: 'disabled:text-primary-8 cursor-not-allowed opacity-50',
                input: 'bg-neutral-2 disabled:text-primary-8 cursor-not-allowed opacity-75'
            }
        },
        {
            isDisabled: true,
            emphasis: 'bold',
            class: {
                inputWrapper: [
                    'bg-primary-1/20',
                    'border-primary-1/40'
                ],
                labelSlot: [
                    'text-primary-1'
                ],
                input: [
                    'text-primary-1 placeholder:text-primary-6',
                    'bg-transparent'
                ]
            }
        },
        {
            error: true,
            emphasis: 'bold',
            class: {
                inputWrapper: [
                    'bg-primary-1/20',
                    'hover:border-error-4 transition',
                    'focus-within:border-error-4',
                    'group-data-focused:hover:border-error-7 transition'
                ],
                labelSlot: [
                    'text-primary-1 group-data-filled:text-primary-1 group-data-focused:text-primary-1',
                    'not-group-data-filled:text-primary-1'
                ],
                input: [
                    'text-primary-1 group-data-filled:text-primary-1 placeholder:text-primary-6',
                    'bg-transparent'
                ],
                errorTextSlot: 'text-error-7'
            }
        },
        {
            error: true,
            emphasis: 'medium',
            class: {
                inputWrapper: [
                    'hover:border-error-8 transition',
                    'focus-within:border-error-8',
                    'group-data-focused:hover:border-error-8 transition',
                    'group-data-focused:shadow-input-error hover:shadow-input-error transition'
                ]
            }
        },
        {
            error: true,
            emphasis: 'regular',
            class: {
                inputWrapper: [
                    'bg-primary-1/20',
                    'hover:border-error-8 transition',
                    'focus-within:border-error-8',
                    'group-data-focused:hover:border-error-8 transition',
                    'group-data-focused:shadow-input-error hover:shadow-input-error transition'
                ]
            }
        },
        {
            size: 'sm',
            class: {
                errorTextSlot: 'pr-1',
                successTextSlot: 'pr-1'
            }
        },
        {
            size: 'md',
            class: {
                errorTextSlot: 'pr-2',
                successTextSlot: 'pr-2'
            }
        },
        {
            size: 'lg',
            class: {
                errorTextSlot: 'pr-2',
                successTextSlot: 'pr-2'
            }
        }
    ],
    defaultVariants: {
        emphasis: 'regular',
        isInset: false,
        size: 'md'
    }
});
const inputTextSizes = Object.keys(inputTextVariants.variants.size);
const inputTextEmphases = Object.keys(inputTextVariants.variants.emphasis);
exports.inputTextEmphases = __webpack_exports__.inputTextEmphases;
exports.inputTextSizes = __webpack_exports__.inputTextSizes;
exports.inputTextVariants = __webpack_exports__.inputTextVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "inputTextEmphases",
    "inputTextSizes",
    "inputTextVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
